import { style } from 'typestyle'
export const mt16 = style({ marginTop: '16px' })
